import {Button, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {useAsyncAction} from "nate-react-api-helpers";
import {useEffect} from "react";
import {api} from "../../../../api/API";
import {useSnackbar} from "../../../../misc/Snackbar";
import {useSyncedRef} from "../../../../misc/SyncedRef";

export function SaveAsPresetDialog(props: {
    category: string;
    description: string;
    onDone(): void;
}) {
    const snack = useSnackbar();
    const doneRef = useSyncedRef(props.onDone);
    const snackRef = useSyncedRef(snack);

    const action = useAsyncAction(async (input: { category: string; description: string }) => {
        await api.quoteMiscPricing.upsertPreset(input);
        snackRef.current.success("Preset saved");
        doneRef.current();
    }, []);

    useEffect(() => {
        action.callback({category: props.category, description: props.description});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog2 open onClose={props.onDone}>
            <DialogTitle>Save as Preset</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Saving "{props.category}" as a preset…
                </DialogContentText>
                {action.LoadingElement}
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onDone} disabled={action.loading}>
                    {action.error ? "Close" : "Cancel"}
                </Button>
            </DialogActions>
        </Dialog2>
    )
}
